import Calculator from "@/components/Calculator"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {Info} from 'lucide-react'

function SapphireCalculator() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Sapphire Price Calculator
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Calculate sapphire carat weight and market value. Professional tool for sapphire price estimation.
          </p>
        </div>

        <div className="mb-12">
          <Calculator 
            defaultGemstone="sapphire"
            title="Sapphire Weight & Price Calculator"
            description="Specialized calculator for sapphire gemstones (SG: 4.0)"
          />
        </div>

        <div className="bg-white rounded-xl shadow-lg border border-blue-100 p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Info className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">About Sapphire Gemstones</h2>
              <p className="text-gray-600 mb-4">
                Sapphires are highly prized precious gemstones from the corundum family. While blue is the most famous color, sapphires come in many colors. They have a specific gravity of 4.0, making them relatively dense and heavy.
              </p>
              <h3 className="font-bold text-gray-900 mb-2">Sapphire Value Factors:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
                <li><strong>Color:</strong> Rich, vivid blue (Kashmir blue) is most valuable</li>
                <li><strong>Clarity:</strong> Eye-clean stones command premium prices</li>
                <li><strong>Cut:</strong> Well-proportioned cuts maximize brilliance</li>
                <li><strong>Origin:</strong> Kashmir, Burma, and Ceylon sapphires are top-tier</li>
                <li><strong>Treatment:</strong> Untreated natural sapphires are most valuable</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Our sapphire calculator provides accurate weight and price estimates to help you make informed decisions when buying or selling sapphire gemstones.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default SapphireCalculator
